import React from 'react';
import Hero from '../components/Hero.js';
import QuantitativeServices from '../components/QuantitativeServices.js';
import ArdenAcademy from '../components/ArdenAcademy.js';
import { useTheme } from '../context/ThemeContext.js';

const HomePage = () => {
  const { isLight } = useTheme();

  return (
    <main>
      <Hero />
      <QuantitativeServices />
      <ArdenAcademy />
      <section className={`relative py-16 sm:py-24 md:py-32 px-4 sm:px-8 md:px-12 flex flex-col items-center justify-center border-t ${
        isLight ? 'border-gray-200 bg-gray-50/50' : 'border-white/5 bg-black/20'
      }`}>
        <div className="text-center space-y-3 sm:space-y-4">
          <h3 className={`text-lg sm:text-xl md:text-2xl font-light tracking-widest uppercase ${
            isLight ? 'text-gray-300' : 'text-white/40'
          }`}>Precision Research End</h3>
          <div className="w-16 sm:w-20 md:w-24 h-[1px] bg-primary mx-auto"></div>
        </div>
      </section>
    </main>
  );
};

export default HomePage;
